import ConfidenceQuestion from "../../mechanics/confidencecalibration/ConfidenceQuestion";
import ConfidenceQuestionCategory from "../../mechanics/confidencecalibration/enum/ConfidenceQuestionCategory";

export const ConfidenceQuestions: ConfidenceQuestion[] = [
	{
		category: ConfidenceQuestionCategory.ANIMALS,
		question: "The elephant is the world's largest mammal.",
		realAnswer: false
	},
	{
		category: ConfidenceQuestionCategory.ANIMALS,
		question: "Sea otters sometimes hold hands while they sleep.",
		realAnswer: true
	},
	{
		category: ConfidenceQuestionCategory.ANIMALS,
		question: "Centipedes have more legs than any other animal.",
		realAnswer: false
	},
	{
		category: ConfidenceQuestionCategory.ANIMALS,
		question: "Mammals and dinosaurs coexisted.",
		realAnswer: true
	},
	{
		category: ConfidenceQuestionCategory.ANIMALS,
		question: "Bears can't climb trees.",
		realAnswer: false
	},
	{
		category: ConfidenceQuestionCategory.ANIMALS,
		question: "Camels store water in their humps.",
		realAnswer: false
	},
	{
		category: ConfidenceQuestionCategory.ANIMALS,
		question: "Flamingos are pink because they eat shrimp.",
		realAnswer: true
	},
	{
		category: ConfidenceQuestionCategory.ANIMALS,
		question: "The giant panda eats mostly bamboo.",
		realAnswer: true
	},
	{
		category: ConfidenceQuestionCategory.ANIMALS,
		question: "The platypus is the only mammal that lays eggs.",
		realAnswer: false
	},
	{
		category: ConfidenceQuestionCategory.ANIMALS,
		question: "A mule is a cross between a male donkey and a female horse.",
		realAnswer: true
	},





	{
		category: ConfidenceQuestionCategory.HISTORICAL_FIGURES,
		question: "Julius Caesar was born before Confucius.",
		realAnswer: false
	},
	{
		category: ConfidenceQuestionCategory.HISTORICAL_FIGURES,
		question: "Fidel Castro was born before Mahatma Gandhi.",
		realAnswer: false
	},
	{
		category: ConfidenceQuestionCategory.HISTORICAL_FIGURES,
		question: "Nelson Mandela was born before Anne Frank.",
		realAnswer: true
	},
	{
		category: ConfidenceQuestionCategory.HISTORICAL_FIGURES,
		question: "Cleopatra was born before Muhammad.",
		realAnswer: true
	},
	{
		category: ConfidenceQuestionCategory.HISTORICAL_FIGURES,
		question: "William Shakespeare was born before Joan of Arc.",
		realAnswer: false
	},
	{
		category: ConfidenceQuestionCategory.HISTORICAL_FIGURES,
		question: "George Washington was born before Sun Tzu.",
		realAnswer: false
	},
	{
		category: ConfidenceQuestionCategory.HISTORICAL_FIGURES,
		question: "Genghis Khan was born before Leonardo da Vinci.",
		realAnswer: true
	},
	{
		category: ConfidenceQuestionCategory.HISTORICAL_FIGURES,
		question: "Queen Victoria was born before Karl Marx.",
		realAnswer: false
	},
	{
		category: ConfidenceQuestionCategory.HISTORICAL_FIGURES,
		question: "Saddam Hussein was born before Marilyn Monroe.",
		realAnswer: false
	},
	{
		category: ConfidenceQuestionCategory.HISTORICAL_FIGURES,
		question: "Albert Einstein was born before Mao Zedong.",
		realAnswer: true
	},




	{
		category: ConfidenceQuestionCategory.DEMOGRAPHICS,
		question: "In 2019, Germany had a larger population than France.",
		realAnswer: true
	},
	{
		category: ConfidenceQuestionCategory.DEMOGRAPHICS,
		question: "In 2019, Japan had a larger population than South Korea.",
		realAnswer: true
	},
	{
		category: ConfidenceQuestionCategory.DEMOGRAPHICS,
		question: "In 2019, Brazil had a larger population than Argentina.",
		realAnswer: true
	},
	{
		category: ConfidenceQuestionCategory.DEMOGRAPHICS,
		question: "In 2019, Egypt had a larger population than Botswana.",
		realAnswer: true
	},
	{
		category: ConfidenceQuestionCategory.DEMOGRAPHICS,
		question: "In 2019, Mexico had a larger population than Guatemala.",
		realAnswer: true
	},
	{
		category: ConfidenceQuestionCategory.DEMOGRAPHICS,
		question: "In 2019, Panama had a larger population than Belize.",
		realAnswer: true
	},
	{
		category: ConfidenceQuestionCategory.DEMOGRAPHICS,
		question: "In 2019, Jamaica had a larger population than Haiti.",
		realAnswer: false
	},
	{
		category: ConfidenceQuestionCategory.DEMOGRAPHICS,
		question: "In 2019, Greece had a larger population than Norway.",
		realAnswer: true
	},
	{
		category: ConfidenceQuestionCategory.DEMOGRAPHICS,
		question: "In 2019, India had a larger population than China.",
		realAnswer: false
	},
	{
		category: ConfidenceQuestionCategory.DEMOGRAPHICS,
		question: "In 2019, Iraq had a larger population than Iran.",
		realAnswer: false
	},





	{
		category: ConfidenceQuestionCategory.SCIENCE,
		question: "Mars has one moon, just like Earth.",
		realAnswer: false
	},
	{
		category: ConfidenceQuestionCategory.SCIENCE,
		question: "Scurvy is caused by a deficit of vitamin C.",
		realAnswer: true
	},
	{
		category: ConfidenceQuestionCategory.SCIENCE,
		question: "Brass is made from iron and copper.",
		realAnswer: false
	},
	{
		category: ConfidenceQuestionCategory.SCIENCE,
		question: "It takes light less than a second to travel from the moon to Earth.",
		realAnswer: false
	},
	{
		category: ConfidenceQuestionCategory.SCIENCE,
		question: "Helium is the lightest element.",
		realAnswer: false
	},
	{
		category: ConfidenceQuestionCategory.SCIENCE,
		question: "The common cold is caused by bacteria.",
		realAnswer: false
	},
	{
		category: ConfidenceQuestionCategory.SCIENCE,
		question: "The deepest place on Earth is in the Pacific Ocean.",
		realAnswer: true
	},
	{
		category: ConfidenceQuestionCategory.SCIENCE,
		question: "Seasons are caused by the earth orbiting the sun in an elliptical path.",
		realAnswer: false
	},
	{
		category: ConfidenceQuestionCategory.SCIENCE,
		question: "Jupiter is the largest planet in our solar system.",
		realAnswer: true
	},
	{
		category: ConfidenceQuestionCategory.SCIENCE,
		question: "The atoms in a solid are more densely packed than the atoms in a gas.",
		realAnswer: true
	},



	{
		category: ConfidenceQuestionCategory.FOOD,
		question: "Gnocchi is made from potatoes.",
		realAnswer: true
	},
	{
		category: ConfidenceQuestionCategory.FOOD,
		question: "Honey is unsafe for newborns to eat because of bacteria.",
		realAnswer: true
	},
	{
		category: ConfidenceQuestionCategory.FOOD,
		question: "The Apollo astronauts ate dehydrated ice cream on the way to the moon.",
		realAnswer: false
	},
	{
		category: ConfidenceQuestionCategory.FOOD,
		question: "One tablespoon of oil has more calories than one tablespoon of butter.",
		realAnswer: true
	},
	{
		category: ConfidenceQuestionCategory.FOOD,
		question: "Bananas are radioactive.",
		realAnswer: true
	},
	{
		category: ConfidenceQuestionCategory.FOOD,
		question: "Pure gold is non toxic.",
		realAnswer: true
	},
	{
		category: ConfidenceQuestionCategory.FOOD,
		question: "Cabernet Sauvignon is a type of red wine.",
		realAnswer: true
	},
	{
		category: ConfidenceQuestionCategory.FOOD,
		question: "Sauerkraut is made by pickling cabbage in vinegar.",
		realAnswer: false
	},
	{
		category: ConfidenceQuestionCategory.FOOD,
		question: "Serrano peppers are generally hotter than habanero peppers.",
		realAnswer: false
	},
	{
		category: ConfidenceQuestionCategory.FOOD,
		question: "Green tea has caffeine.",
		realAnswer: true
	},




	{
		category: ConfidenceQuestionCategory.LITERATURE,
		question: "The King James Bible has over a million words.",
		realAnswer: false
	},
	{
		category: ConfidenceQuestionCategory.LITERATURE,
		question: "The Great Gatsby was written in the 1930s.",
		realAnswer: false
	},
	{
		category: ConfidenceQuestionCategory.LITERATURE,
		question: "Wuthering Heights was written by Emily Bronte.",
		realAnswer: true
	},
	{
		category: ConfidenceQuestionCategory.LITERATURE,
		question: "The Godfather was based off a book.",
		realAnswer: true
	},
	{
		category: ConfidenceQuestionCategory.LITERATURE,
		question: "Fortuity means about the same thing as serendipity.",
		realAnswer: true
	},
	{
		category: ConfidenceQuestionCategory.LITERATURE,
		question: "Capricious means about the same thing as luxurious.",
		realAnswer: false
	},
	{
		category: ConfidenceQuestionCategory.LITERATURE,
		question: "Times New Roman is a sans-serif font.",
		realAnswer: false
	},
	{
		category: ConfidenceQuestionCategory.LITERATURE,
		question: "Watchmen was published before The Handmaid's Tale.",
		realAnswer: false
	},
	{
		category: ConfidenceQuestionCategory.LITERATURE,
		question: "Full Metal Jacket is under two hours long.",
		realAnswer: true
	},
	{
		category: ConfidenceQuestionCategory.LITERATURE,
		question: "Tolkien wrote The Lord of the Rings during World War I.",
		realAnswer: false
	},




	{
		category: ConfidenceQuestionCategory.INVENTIONS,
		question: "Pop Tarts were invented before the Easy Bake Oven.",
		realAnswer: false
	},
	{
		category: ConfidenceQuestionCategory.INVENTIONS,
		question: "Calculus was invented before the hot air balloon.",
		realAnswer: true
	},
	{
		category: ConfidenceQuestionCategory.INVENTIONS,
		question: "Gunpowder was invented in China.",
		realAnswer: true
	},
	{
		category: ConfidenceQuestionCategory.INVENTIONS,
		question: "Albert Einstein was part of the Manhattan Project.",
		realAnswer: false
	},
	{
		category: ConfidenceQuestionCategory.INVENTIONS,
		question: "The Band-Aid was invented before the blender.",
		realAnswer: true
	},
	{
		category: ConfidenceQuestionCategory.INVENTIONS,
		question: "The Nintento Wii was invented before the iPhone.",
		realAnswer: true
	},
	{
		category: ConfidenceQuestionCategory.INVENTIONS,
		question: "The trireme was invented before glass blowing.",
		realAnswer: true
	},
	{
		category: ConfidenceQuestionCategory.INVENTIONS,
		question: "Penicillin was discovered before a smallpox vaccine.",
		realAnswer: false
	},
	{
		category: ConfidenceQuestionCategory.INVENTIONS,
		question: "Chess was invented before Go.",
		realAnswer: false
	},
	{
		category: ConfidenceQuestionCategory.INVENTIONS,
		question: "The sound barrier was breached in a supersonic aircraft before the first rocket reached space.",
		realAnswer: false
	},
];